import {ChangeDetectorRef, Component, Input} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {DateConversionPipe} from '../../pipes/date-conversion.pipe';
import {IncidentsService} from '../../services/incidents.service';
import {NgxSpinnerModule, NgxSpinnerService} from 'ngx-spinner';
import {NgbModal, NgbModalModule} from '@ng-bootstrap/ng-bootstrap';
import {environment} from 'src/environments/environment';
import {PaginatedIncidentComponentBase} from '../../shared/paginated-incident.component';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-damage-incident',
  templateUrl: './damage-incident.component.html',
  standalone: true,
  imports: [
    TranslatePipe,
    DateConversionPipe,
    NgxSpinnerModule,
    NgbModalModule
  ],
  styleUrl: './damage-incident.component.scss'
})

export class DamageIncidentComponent extends PaginatedIncidentComponentBase<any, any> {
  host: string = environment.host;

  damageEvents;
  @Input() filter?: string;

  constructor(incidentService: IncidentsService,
              spinnerService: NgxSpinnerService,
              cdRef: ChangeDetectorRef,
              modalService: NgbModal) {
    super(incidentService, spinnerService, cdRef, modalService);
  }

  protected override get incidentPage(): any {
    return this.damageEvents;
  }

  protected override set incidentPage(value: any) {
    this.damageEvents = value;
  }

  protected override get filterValue(): string | undefined {
    return this.filter;
  }

  protected override fetchPage(licencePlate?: string, skip?: number, limit?: number): Observable<any> {
    return this.incidentService.getDamageIncidents(licencePlate, skip, limit);
  }
}
